import {EventEmitter, Injectable} from "@angular/core";
import {FacadeService} from "../../shared/services/facade.service";
import {BehaviorSubject} from "rxjs";
import {ValidationDetail} from "../../shared/models/ValidationDetail";
import {IncomeSource} from "../../shared/models/income-source";

@Injectable({
  providedIn: 'root'
})
export class CreateApplicationService {

  public idleDialogVisible: boolean = false;
  public formElementHasChanged: boolean = false;
  public validationsChange = new EventEmitter<ValidationDetail>();
  public onTriggerValidations = new EventEmitter<void>();
  //private _incomeSources$: BehaviorSubject<Array<IncomeSource>> = new BehaviorSubject([]);

  constructor(private facadeService: FacadeService) {
  }

  triggerValidation(): void {
    this.onTriggerValidations.emit();
  }
}
